import type { ReactNode } from 'react';

export const symbol_phone_missed: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="m136-146-94-94q-9-9-8.5-21t8.5-22q82-96 197-146.5T480-480q126 0 241 50.5T918-283q8 10 8.5 22t-8.5 21l-94 94q-8 8-23 9t-24-6l-114-85q-6-4.5-9-10.5t-3-13.5v-139q-42-16-85.5-22.5T480-420q-42 0-85.5 6.5T309-391v139q0 7.5-3 13.5t-9 10.5l-114.19 85.28q-11.81 8.72-24.5 7.8-12.68-.93-22.31-11.08Zm108-224q-38 19-73 45.5T104-268l57 59 83-61v-100Zm467-4v98l87 66 58-58q-32-33-68.5-58.5T711-374Zm-467 4Zm467-4ZM216.5-623.63Q208-632.25 208-645v-165q0-12.75 8.63-21.38Q225.25-840 238-840h165q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5h-96l173 171 210-210q9-9 21.5-9.5t21.5 8.55q9 9.06 9 21.5 0 12.45-9 21.45L522-566q-18 18-43.03 18-25.04 0-41.97-18L268-737v92q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63Z"
		/>
	</svg>
);
